<script>
import InputSwitch from 'primevue/inputswitch';
import BaseVolanInput from './BaseVolanInput';
export default {
  name: 'VolanSwitch',
  components: {InputSwitch},
  extends: BaseVolanInput,
  inheritAttrs: true,
  props: {
    notFixValue: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {

    };
  },
  computed: {
  },
  watch: {
    value(val) {
      if(!this.notFixValue && val!==false && val!==true) {
        this.$emit('input', false);
      }
    }
  },
  created() {
    if(!this.notFixValue && this.value!==false && this.value!==true) {
      this.$emit('input', false);
    }
  },

};
</script>

<template>
  <span class="flex flex-row align-center mt-1 mb-2 pt-1 pb-1">
    <InputSwitch :id="computedId"
                 v-bind="$attrs"
                 :value="value"
                 :disabled="isDisabled"
                 :readonly="isReadonly"
                 v-on="$listeners"
                 @focus="onInputFocus"
                 @blur="onInputBlur"
    />
    <label class="ml-2"
           :for="computedId"
    >{{ computedLabel }}</label>
    <small v-if="hintComputed"
           class="block"
    >{{ hintComputed }}</small>
  </span>
</template>